<ng-container *ngIf="bundledWithAngularJSApp; else mobile">
  <ng-container *ngIf="suggestion.knowledge_documents && suggestion.knowledge_documents.length; else noDoc">
    <ng-container [ngSwitch]="suggestion.knowledge_documents.length">
      <ng-container *ngSwitchCase="1">
        <span
          class="documents-used"
          translate="m/task-process/ai-assistant/modale/title/doc"
          [translateParams]="{ nb: suggestion.knowledge_documents?.length }"></span>
        &nbsp;:&nbsp;

        <ng-container
          *ngTemplateOutlet="documentLink; context: { document: suggestion.knowledge_documents[0] }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <span
          class="documents-used"
          translate="m/task-process/ai-assistant/modale/title/docs"
          [translateParams]="{ nb: suggestion.knowledge_documents?.length }"></span>
        &nbsp;:&nbsp;

        <span class="blue-text">{{ suggestion.knowledge_documents[0].title }}</span>

        <ng-container *ngTemplateOutlet="seeAll"></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #mobile>
  <ng-container *ngIf="suggestion.knowledge_documents && suggestion.knowledge_documents.length; else noDoc">
    <ng-container [ngSwitch]="suggestion.knowledge_documents.length">
      <ng-container *ngSwitchCase="1">
        <span
          class="documents-used blue-text"
          (click)="displayedKdPopover($event)"
          translate="m/task-process/ai-assistant/modale/title/doc"
          [translateParams]="{ nb: suggestion.knowledge_documents?.length }"></span>
        &nbsp;:
      </ng-container>
      <ng-container *ngSwitchDefault>
        <a
          class="documents-used blue-text"
          (click)="displayedKdPopover($event)"
          translate="m/task-process/ai-assistant/modale/title/docs"
          [translateParams]="{ nb: suggestion.knowledge_documents?.length }"></a>
        &nbsp;:
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<!------ templates ------>

<ng-template #noDoc>:</ng-template>

<ng-template #seeAll>
  <ion-button
    fill="clear"
    (click)="displayedKdPopover($event)"
    translate="m/task-process/ai-assistant/modale/title/see-all-docs"></ion-button>
</ng-template>

<ng-template #documentLink let-document="document">
  <a *ngIf="document.url; else noUrl" [href]="document.url" target="_blank"
    >{{ document.title }} <ion-icon name="open-outline"></ion-icon
  ></a>

  <ng-template #noUrl>
    <span>{{ document.title }}</span>
  </ng-template>
</ng-template>

<ion-popover
  #popover
  [isOpen]="isPopoverDisplayed"
  (didDismiss)="isPopoverDisplayed = false"
  class="suggestion-knowledge-documents-popover">
  <ng-template>
    <div class="content">
      <div *ngFor="let doc of suggestion.knowledge_documents">
        <ng-container *ngTemplateOutlet="documentLink; context: { document: doc }"></ng-container>
      </div>
    </div>
  </ng-template>
</ion-popover>
